/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Group, Highlight, SelectItemProps, Text } from '@mantine/core';
import { forwardRef } from 'react';
import Moment from 'react-moment';
import EventDate from '../../Types/EventDate';
import Contact from '../../Types/Contact';
import BookingState from '../../Types/Enums/BookingState';
import { EventS } from '../../Service/EventS';
import { CustomEventState } from '../../Types/EventT';
import BookingEvent from '../../Types/Event';

interface EventItemProps extends SelectItemProps {
  customer: Contact;
  bookingState: BookingState;
  kind?: string;
  dates: EventDate[];
  eventName: string | null;
  eventState: CustomEventState | null;
  query?: string;
}

const AutoCompleteEventItem = forwardRef<HTMLDivElement, EventItemProps>(
  ({ customer, bookingState, kind, dates, eventState, eventName, query, ...rest }: EventItemProps, ref) => {
    const stateColor = EventS.getStateColor({ bookingState, eventState } as BookingEvent);
    const stateLabel = eventState
      ? `${eventState.emoji ? `${eventState.emoji} ` : ''}${eventState.label}`
      : EventS.translateBookingState(bookingState);
    const normalizedQuery = query?.trim() || '';
    const safeEventName = eventName ?? '';
    const customerLabel = customer.personDescription || customer.email || '';

    return (
      <Box
        ref={ref}
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]}`,
          padding: '10px 12px',
          background: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
          transition: 'background-color 120ms ease',
          borderRadius: 8,
        })}
        {...rest}
      >
        <Group spacing={8} sx={{ marginBottom: 6 }}>
          <Text
            sx={(theme) => ({
              fontSize: 10,
              fontWeight: 700,
              color: eventState?.color || (theme.colorScheme === 'dark' ? theme.colors.gray[0] : stateColor),
              background:
                eventState?.bgColor || (theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]),
              padding: '2px 8px',
              borderRadius: 999,
              lineHeight: 1.2,
              maxWidth: '100%',
            })}
          >
            {stateLabel}
          </Text>
        </Group>

        {safeEventName !== '' && (
          <Highlight
            highlight={normalizedQuery}
            sx={(theme) => ({
              fontSize: 14,
              fontWeight: 700,
              lineHeight: 1.25,
              marginBottom: 3,
              color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : '#1f2937',
            })}
          >
            {safeEventName}
          </Highlight>
        )}

        <Highlight
          highlight={normalizedQuery}
          sx={(theme) => ({
            fontSize: 12,
            color: theme.colorScheme === 'dark' ? theme.colors.gray[3] : '#4b5563',
            lineHeight: 1.3,
            marginBottom: dates.length > 0 ? 4 : 0,
          })}
        >
          {customerLabel}
        </Highlight>

        {dates.length > 0 && (
          <Text
            sx={(theme) => ({
              fontSize: 11,
              fontWeight: 600,
              color: theme.colorScheme === 'dark' ? theme.colors.gray[4] : '#6b7280',
              letterSpacing: 0.2,
            })}
          >
            {EventS.getKindDescription(kind)} am <Moment format="DD.MM.YYYY">{dates[0].date}</Moment>
          </Text>
        )}
      </Box>
    );
  },
);

export default AutoCompleteEventItem;
